function IconSupplyChain() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M16 22L32 12L48 22V42L32 52L16 42V22Z" stroke="#F5B400" strokeWidth="3" />
      <path d="M16 22L32 32L48 22" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 32V52" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconQuality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M32 10L50 18V30C50 42 42 50 32 54C22 50 14 42 14 30V18L32 10Z"
        stroke="#F5B400"
        strokeWidth="3"
      />
      <path d="M24 32L30 38L42 24" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconMarketKnowledge() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="20" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 12V52" stroke="#F5B400" strokeWidth="3" />
      <path d="M12 32H52" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconPartnerships() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="22" cy="20" r="5" stroke="#F5B400" strokeWidth="3" />
      <circle cx="42" cy="20" r="5" stroke="#F5B400" strokeWidth="3" />
      <path d="M16 40C16 32 20 28 22 28C24 28 28 32 28 40" stroke="#F5B400" strokeWidth="3" />
      <path d="M36 40C36 32 40 28 42 28C44 28 48 32 48 40" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconSatisfaction() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M32 10L38 24L54 26L42 38L46 54L32 46L18 54L22 38L10 26L26 24L32 10Z"
        stroke="#F5B400"
        strokeWidth="3"
      />
    </svg>
  )
}

function IconGlobalTrade() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="22" stroke="#F5B400" strokeWidth="3" />
      <path d="M10 32H54" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C40 18 40 46 32 54" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C24 18 24 46 32 54" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconCompany() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="16" y="14" width="32" height="36" stroke="#333" strokeWidth="3" />
      <path d="M24 22H28V26H24V22Z" fill="#333" />
      <path d="M36 22H40V26H36V22Z" fill="#333" />
      <path d="M24 32H28V36H24V32Z" fill="#333" />
      <path d="M36 32H40V36H36V32Z" fill="#333" />
    </svg>
  )
}

function IconSupplierNetwork() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="5" stroke="#333" strokeWidth="3" />
      <circle cx="44" cy="20" r="5" stroke="#333" strokeWidth="3" />
      <circle cx="32" cy="42" r="5" stroke="#333" strokeWidth="3" />
      <line x1="20" y1="25" x2="32" y2="37" stroke="#333" strokeWidth="3" />
      <line x1="44" y1="25" x2="32" y2="37" stroke="#333" strokeWidth="3" />
      <line x1="20" y1="20" x2="44" y2="20" stroke="#333" strokeWidth="3" />
    </svg>
  )
}

function IconOptimization() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="8" stroke="#333" strokeWidth="3" />
      <path d="M32 12V20M32 44V52M12 32H20M44 32H52" stroke="#333" strokeWidth="3" />
      <path d="M18 18L23 23M41 41L46 46M46 18L41 23M18 46L23 41" stroke="#333" strokeWidth="3" />
    </svg>
  )
}

function IconExpansion() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M14 50H50" stroke="#333" strokeWidth="3" />
      <path d="M20 50V34" stroke="#333" strokeWidth="4" />
      <path d="M32 50V24" stroke="#333" strokeWidth="4" />
      <path d="M44 50V14" stroke="#333" strokeWidth="4" />
      <path d="M18 18L30 10L42 18L52 8" stroke="#333" strokeWidth="3" />
    </svg>
  )
}

function IconFutureGrowth() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="18" stroke="#333" strokeWidth="3" />
      <circle cx="32" cy="32" r="8" stroke="#333" strokeWidth="3" />
      <circle cx="32" cy="32" r="2" fill="#333" />
      <path d="M44 20L54 10" stroke="#333" strokeWidth="3" />
      <path d="M48 10H54V16" stroke="#333" strokeWidth="3" />
    </svg>
  )
}

export const achievementsSuccessIcons = {
  'supply-chain': IconSupplyChain,
  quality: IconQuality,
  'market-knowledge': IconMarketKnowledge,
  partnerships: IconPartnerships,
  satisfaction: IconSatisfaction,
  'global-trade': IconGlobalTrade,
}
export const achievementsTimelineIcons = {
  company: IconCompany,
  'supplier-network': IconSupplierNetwork,
  optimization: IconOptimization,
  expansion: IconExpansion,
  'future-growth': IconFutureGrowth,
}

